import { Box, TextField } from "@mui/material";
import { set_snack_bar } from "actions/snackbar/snackbar_action";
import React, { useEffect, useState } from "react";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const EmailQuestion = ({
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  useEffect(() => {
    if (submittedAnswer?.length > 0) {
      setEmail(submittedAnswer?.[0]?.value || "");
      setCommentBox(submittedAnswer?.[0]?.comment || "");
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const validateEmail = (eAddress) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(eAddress);
  };

  const handleUpdate = (type, data) => {
    let newEmail = email;
    let newComment = commentBox;

    if (type === "email") {
      newEmail = data;
      setEmail(data);
    } else if (type === "comment") {
      newComment = data;
      setCommentBox(data);
    } else if (type === "document") setAttachDocument(data);

    if (isFrom === "taskSection") {
      if (validateEmail(newEmail)) {
        setError(false);
      } else {
        setError(true);
        set_snack_bar(true, "Please enter a valid email address");
      }

      handleQuesAnswer({
        obj: {
          value: newEmail,
          weight: 1,
          comment: newComment,
          supporting_document:
            type === "document" && data === null ? data : attachDocument,
          document: type === "document" ? data : attachDocument,
          documentMetaData:
            type === "document"
              ? {
                  ques_id: question?._id,
                  name: data?.name,
                  is_supporting_document: true,
                  type: data?.type,
                }
              : null,
        },
        realQuestion: question,
      });
    }
  };

  const placeholderSize = {
    inputProps: { sx: { fontSize: "14px" } },
  };
  const labelSize = { style: { fontSize: "14px" } };

  return (
    <Box
      style={{ pointerEvents: event }}
      mt={2}
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <TextField
        label="Email"
        variant="outlined"
        fullWidth
        value={email}
        onChange={(e) => handleUpdate("email", e.target.value)}
        error={isFrom === "taskSection" ? error : false}
        size="small"
        InputLabelProps={labelSize}
        InputProps={placeholderSize}
      />

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            name="comment"
            data={commentBox}
            placeholder="Contributor's comment"
            handleChange={({ name, value }) => handleUpdate(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleUpdate}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default EmailQuestion;
